<template>
    <ul class="navigation">
        <router-link tag="li" active-class="navigation__active" :to="{name: 'dashboard'}">
            <a><i class="zmdi zmdi-home"></i> Home</a>
        </router-link>

        <router-link tag="li" active-class="navigation__active" :to="{name: 'growers.browse'}">
            <a><i class="zmdi zmdi-accounts"></i> Growers</a>
        </router-link>

        <li class="navigation__sub" :class="{'navigation__sub--active': isActiveItem('/blocks')}">
            <b-link @click="toggleBlocks">
                <i class="zmdi zmdi-view-week"></i> Final Spray Blocks
            </b-link>

            <keep-alive>
                <ul v-if="showBlocks" class="animated">
                    <li class="navigation__sub">
                        <router-link class="navigation__heading" active-class="navigation__active"
                                     :to="{name: 'final-spray.blocks.browse'}" exact>
                            All Blocks
                        </router-link>
                    </li>

                    <li class="navigation__sub" v-for="cropType in sortedLinkedCropTypes" :key="cropType.id">
                        <router-link class="navigation__heading" active-class="navigation__active"
                                     :to="{name: 'final-spray.blocks.crop-type.browse', params: {cropTypeId: cropType.id}}" exact>
                            {{ cropType.name }}
                        </router-link>
                    </li>
                </ul>
            </keep-alive>
        </li>

        <router-link tag="li" active-class="navigation__active" :to="{name: 'spray-diary.browse', params: {startRange: buildRange(14)}}">
            <a><i class="zmdi zmdi-time-countdown"></i> Spray Logs (14 days)</a>
        </router-link>

        <router-link tag="li" active-class="navigation__active" :to="{name: 'spray-diary.browse', params: {startRange: buildRange(21)}}">
            <a><i class="zmdi zmdi-time-countdown"></i> Spray Logs (21 days)</a>
        </router-link>

        <li class="navigation__sub" :class="{'navigation__sub--active': isActiveItem('/setup')}">
            <b-link @click="toggleSetup">
                <i class="zmdi zmdi-settings"></i> Setup
            </b-link>

            <keep-alive>
                <ul v-if="showSetup" class="animated">
                    <router-link tag="li" active-class="navigation__active" :to="{name: 'setup'}" exact>
                        <a>Account</a>
                    </router-link>

                    <router-link tag="li" active-class="navigation__active" :to="{name: 'setup', params: {view: 'processor-crop-types'}}">
                        <a>Crop Types</a>
                    </router-link>
                    <router-link tag="li" active-class="navigation__active" :to="{name: 'setup', params: {view: 'regions'}}">
                        <a>Regions</a>
                    </router-link>
                </ul>
            </keep-alive>
        </li>

    </ul>
</template>

<script>
import listLinkedCropTypesQuery from '@components/Sidebars/Processor/queryListFinalSprayLinkedCropTypes.graphql';
import {differenceInDays, format as dateFormat, isToday, subDays} from 'date-fns';


export default {
  name: 'ProcessorAppSidebar',
  apollo: {
    linkedCropTypes: {
      query: listLinkedCropTypesQuery,
      update: data => data.filterBlocks.data,
      variables() {
        return {
          input: {
            final_spray: true,
          },
        };
      },
      result({ data, loading }) {
      },
    },
  },
  data() {
    return {
      linkedCropTypes: [],
      showBlocks: this.isActiveItem('/blocks'),
      showSetup: this.isActiveItem('/setup'),
      loading: 0,
    };
  },
  computed: {
    sortedLinkedCropTypes() {
      const cropTypes = {};
      this.linkedCropTypes.forEach(block => cropTypes[block.cropType.id] = block.cropType);
      return Object.values(cropTypes).sort(
        ({ name: a }, { name: b }) => (a < b ? -1 : a > b ? 1 : 0),
      );
    },
  },
  methods: {
    buildRange(days) {
      const end = new Date();
      const start = subDays(end, days);
      return `${dateFormat(start, 'YYYY-MM-DD')} to ${dateFormat(end, 'YYYY-MM-DD')}`;
    },
    isActiveItem(url) {
      return this.$route.path.startsWith(url);
    },
    toggleBlocks() {
      this.showBlocks = !this.showBlocks;
    },
    toggleSetup() {
      this.showSetup = !this.showSetup;
    },
  },
};
</script>
